import toast from "react-hot-toast";
import { httpRequest } from "src/services/httpRequest";

// Get the block lots with address
export const getBlockLots = async (val) => {
  const response = await httpRequest(
    'GET',
    `/propertyDetails/searchBlockLots_Address?PropertyBlockLot=${val}`
  );
  if (response?.status === 'success') {
    const list = response?.data
      ?.map((value: { BlockLot: string }) => {
        return { ...value, label: value?.BlockLot };
      })
      ?.slice(0, 10);
    return (list);
  } else {
    toast.error(response?.message);
  }
};
